import { useQuery } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { type CellContext, type RowData } from "@tanstack/react-table";

import { type DataTableFeatures } from "src/components/dataTableFeatures";
import { useLabelsRepository } from "src/contexts/LabelsRepositoryContext";

import { type LabelPickerLabel } from "./LabelPicker";
import { LabelsCell } from "./LabelsCell";

export function createLabelsCell<TData extends RowData>(options: {
  getLabels: (row: TData) => LabelPickerLabel[];
  save: (row: TData, labelIds: string[]) => Promise<unknown>;
}) {
  return function LabelsTableCell(
    ctx: CellContext<DataTableFeatures, TData, unknown>,
  ) {
    const router = useRouter();
    const labelsRepository = useLabelsRepository();
    const labelsQuery = useQuery(labelsRepository.listOptions);
    const row = ctx.row.original;

    return (
      <LabelsCell
        labels={options.getLabels(row)}
        allLabels={labelsQuery.data ?? []}
        onSave={async (labelIds) => {
          await options.save(row, labelIds);
          router.invalidate();
        }}
      />
    );
  };
}
